
/******************************************************************************************
Hardware
******************************************************************************************/

/*
  --name <string>
  --manufacturer <Manufacturer>
  --manufacturerNumber <string>
  --computerEaseNumber <string>
  --description <string::textarea>
  --finish <combobox enum>

  /Brackets
    --name <string>
    --mountType <string::enum> | ['Surface', 'In Wall', 'Hidden']
    --length <string>
    --loadWeight <float> | pounds
    --minShelfDepth <float> | inches
    --maxShelfDepth <float | inches : 'Good for shelves of depth X" to Y"'

  /Cabinets
    /Catches
      --type <string::enum> | ['Magnetic', 'Ball', 'Spring', 'Elbow']
      --pair <boolean::switch> | ['Pair', 'Individual']
      --single <boolean::switch> | ['Single', 'Double']

    /Hinges & Plates
      --closeType <string::enum> | ['Soft', 'Free Swing', 'Self']
      --degreeOfOpen <float> | degrees
      --attachmentMethod <string::enum> | ['Insert', 'Screw', 'Press In']
      --overlay <string::enum> ['Inset', 'Full', 'Half']
      --loadWeight <float> | pounds

    /Hinge Plates
      --thickness <float::enum> | millimeters | [0, 3, 6, 9, 18]
      --wedges <bool> | checkbox

    /Locks
      --mount <string::enum> | ['Horizontal', 'Vertical']
      --setBack <float> | inches
      --throwDistance <float> | inches
      --materialThickness <float> | inches | default: 3/4"

    /Pulls
      --type <string::enum> | ['Tab', 'Wire', 'Knob', 'Bar', 'Extrusion']
      /Tab, Wire, Bar
        --length <float> | inches
      /Knob
        --diameter <float> | inches
      /Extrusion
        // Ordered in Linear Ft, or "pieces" & "length"
        // So: 15 linear ft, or 5 pieces @ 6' per piece

    /Slides
      --length <float> | inches
      --closingMechanism <string::combobox>
      --loadWeight <float> | pounds
      --overTravel <float> | inches | default: 0
      --mountType <string::enum> | ['Side Mount', 'Under Mount']

  /Closets
    /End Caps
      --diameter <float::enum> | inches | ['6 1/16th', '6 5/16th']
    /Flanges
      --diameter <float::enum> | inches | ['6 1/16th', '6 5/16th']
    /Rod Supports
    /Rods
      --diameter <float::enum> | inches | ['6 1/16th', '6 5/16th']
      --length <float> | inches

  /Doors & Frames
    /Closers
      --closer <boolean::switch> | ['Top', 'Bottom']
    /Hinges
      --type <string:: enum> | ['Five-Knuckle', 'Top Pivot', 'Bottom Pivot', 'Intermediate Pivot', 'Top & Bottom Pivot']
    /Lock Sets

  /Fasteners
    --type <string::enum> | ['Bed Rail', 'Biscuit', 'Keyhole', 'Clips', 'Tite Joint']
    --pair <boolean::switch> | ['Pair', 'Individual']

  /Grommets
    --liner <bool> | checkbox
    /Round
      --diameter <float> | inches
    /Paper
      --width <float> | inches
      --length <float> | inches
    /Square
      --width <float> | inches
      --length <float> | inches

  /Trash Bins
  /Nuts
  /
*/

const name = 'Hardware'
const id = 'oA5mwxfychjg2kC83w73'

export default {
  name,
  id
}
